// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import {
  additionalExpense,
  changeStatusJob,
  convertJobToSchedule,
  createJob,
  deleteJob,
  getDetailJob,
  getListJob,
  getListJobItem,
  getListJobKanban,
  updateJob,
} from './jobThunk';

export interface IJobState {
  isRefreshJobList: boolean;
  isRefreshJobDetail: boolean;
}

export const initialState: IJobState = {
  isRefreshJobList: true,
  isRefreshJobDetail: false,
};

const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    setRefreshJobList(state, action) {
      state.isRefreshJobList = action.payload;
    },

    setRefreshJobDetail(state, action) {
      state.isRefreshJobDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    // POST: Create job
    builder
      .addCase(createJob.pending, (_state) => {})
      .addCase(createJob.fulfilled, (_state) => {})
      .addCase(createJob.rejected, (_state) => {});

    // PUT: Update job
    builder
      .addCase(updateJob.pending, (_state) => {})
      .addCase(updateJob.fulfilled, (state) => {
        state.isRefreshJobList = true;
        state.isRefreshJobDetail = true;
      })
      .addCase(updateJob.rejected, (_state) => {});

    // PUT: Change status job
    builder
      .addCase(changeStatusJob.pending, (_state) => {})
      .addCase(changeStatusJob.fulfilled, (_state) => {})
      .addCase(changeStatusJob.rejected, (_state) => {});

    // GET: get list job
    builder
      .addCase(getListJob.pending, (_state) => {})
      .addCase(getListJob.fulfilled, (_state) => {})
      .addCase(getListJob.rejected, (_state) => {});

    // GET: get list job kanban
    builder
      .addCase(getListJobKanban.pending, (_state) => {})
      .addCase(getListJobKanban.fulfilled, (_state) => {})
      .addCase(getListJobKanban.rejected, (_state) => {});

    // GET: get list job item
    builder
      .addCase(getListJobItem.pending, (_state) => {})
      .addCase(getListJobItem.fulfilled, (_state) => {})
      .addCase(getListJobItem.rejected, (_state) => {});

    // GET: get detail job
    builder
      .addCase(getDetailJob.pending, (_state) => {})
      .addCase(getDetailJob.fulfilled, (state) => {
        state.isRefreshJobDetail = false;
      })
      .addCase(getDetailJob.rejected, (_state) => {});

    // DELETE: delete job
    builder
      .addCase(deleteJob.pending, (_state) => {})
      .addCase(deleteJob.fulfilled, (_state) => {})
      .addCase(deleteJob.rejected, (_state) => {});

    // PUT: additional expense
    builder
      .addCase(additionalExpense.pending, (_state) => {})
      .addCase(additionalExpense.fulfilled, (_state) => {
        _state.isRefreshJobDetail = true;
      })
      .addCase(additionalExpense.rejected, (_state) => {});

    // POST: Convert to schedule
    builder
      .addCase(convertJobToSchedule.pending, (_state) => {})
      .addCase(convertJobToSchedule.fulfilled, (_state) => {})
      .addCase(convertJobToSchedule.rejected, (_state) => {});
  },
});

// Action
export const jobActions = jobSlice.actions;

// Selectors

// Reducer
const jobReducer = jobSlice.reducer;
export default jobReducer;
